import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/matchDays";

export async function getMatchDays() {
  const response = await http.get(apiEndpoint);
  return response.data;
}

export async function getMatchDay(id) {
  const response = await http.get(apiEndpoint + "/" + id);
  return response.data;
}

export async function saveMatchDay(matchDay) {
  let matchDayInDb = matchDay || {};
  matchDayInDb.name = matchDay.name;

  if (matchDayInDb.id === -1) await http.post(apiEndpoint, matchDayInDb);
  else await http.put(apiEndpoint + "/" + matchDayInDb.id, matchDayInDb);

  return matchDayInDb;
}

export async function deleteMatchDay(id) {
  await http.delete(apiEndpoint + "/" + id);
}



// WEBPACK FOOTER //
// ./src/services/matchDayService.js